var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_842_268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.667 5.63745H14.7418C10.6901 5.63745 7.40145 9.69856 7.37325 14.7201H2.33447V23.8701H9.25966C13.3114 23.8701 16.6 19.809 16.6282 14.7875H21.6655V5.63745H21.667Z",
    fill: "url(#paint0_linear_842_268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.848 23.2887C7.46259 24.1927 7.37172 17.6341 7.37172 17.2236V10.7278C7.37015 5.67331 4.07051 1.57617 0 1.57617V22.5789C0 23.2918 0.465335 23.8699 1.04034 23.8699H7.37015H9.2597C10.17 23.8699 11.0427 23.6631 11.848 23.2887Z",
    fill: "url(#paint1_linear_842_268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9598 5.63745H14.7404C13.8301 5.63745 12.9574 5.84427 12.1521 6.21873C16.5375 5.31469 16.6284 11.8733 16.6284 12.2838V18.7796C16.6284 23.8325 19.9281 27.9297 23.9986 27.9297V6.92848C23.9986 6.21559 23.5332 5.63745 22.9582 5.63745H22.9598Z",
    fill: "url(#paint2_linear_842_268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0776 4.11751H24.0016C24.0016 4.11751 20.2555 3.54563 18.0776 0V4.11751Z",
    fill: "url(#paint3_linear_842_268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92401 25.3442H0C0 25.3442 3.74618 25.9161 5.92401 29.4617V25.3442Z",
    fill: "url(#paint4_linear_842_268)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_268",
    x1: 1.91614,
    y1: 26.6449,
    x2: 15.6709,
    y2: 10.4271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1D47C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D39C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7122C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_842_268",
    x1: 6.03995,
    y1: -5.06386,
    x2: 5.79397,
    y2: 32.0658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFA919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_842_268",
    x1: 18.1983,
    y1: -1.07465,
    x2: 17.9508,
    y2: 36.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_842_268",
    x1: 20.7913,
    y1: 14.2797,
    x2: 21.3632,
    y2: -13.9726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_842_268",
    x1: 3.06776,
    y1: 17.0575,
    x2: 2.95339,
    y2: 28.2679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FC6432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC1A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_842_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 29.4618,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexa);
export default __webpack_public_path__ + "static/media/nexa.8fec3e27b25fbbbcb88cec4b5c01b5ea.svg";
export { ForwardRef as ReactComponent };